import { render, staticRenderFns } from "./PostingList.vue?vue&type=template&id=2aaa6b72&"
import script from "./PostingList.vue?vue&type=script&lang=js&"
export * from "./PostingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports